import React from "react";

// COMPONENTS
import Layout from "../layout/Layout";
import Icon from "../icons/Icon";

const Message = ({ msg, type, removeShadow, fontWeight, textOnly }) => {
  const alerterType = {
    default: "bc12",
    success: "bc6 c1",
    error: "bc5 c4",
  }[type || "default"];

  const borderStyles = () => {
    let classes = '';

    if(!removeShadow) classes = "sh1";
    if(textOnly) classes = "__m_r"
    return classes;
  }

  return (
    <div data-test="message" data-component_name="Message">
      <Layout flex addClass={`__m  ${borderStyles()} ${alerterType}`}>
      <Layout flex alignItemsCenter>
        <Icon iconId="infoFull" />
      </Layout>
      <Layout
        flex
        flex1
        alignItemsCenter
        addClass={`__m_t`}
        styles={{ fontWeight: fontWeight || "bold" }}
      >
        {msg}
      </Layout>
      {/* <Layout flex alignItemsCenter>
        {close && <Icon iconId="x" />}
      </Layout> */}
    </Layout>
    </div>
  );
};

export default Message;
